export interface GetSampleCompanyRequest {
    industry_type: string;
}

export interface SampleCompanyInfo {
    logo?: string;
    company_id: string;
    name: string;
    country_name?: string;
    founded_date?: number;
    employee_number?: number;
    description?: string;
}
export type GetSampleCompanyResponse = SampleCompanyInfo[];

export const CompanyEurekaApi = Symbol('CompanyEurekaApi');

export interface CompanyEurekaApi {
    getSampleCompany(params: GetSampleCompanyRequest): Promise<GetSampleCompanyResponse>
}
